<div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
    <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__body">
            <div class="forbidden-container">
                <div class="error-icon">
                    <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="#ef4444" stroke-width="2" />
                        <path d="M15 9l-6 6" stroke="#ef4444" stroke-width="2" stroke-linecap="round" />
                        <path d="M9 9l6 6" stroke="#ef4444" stroke-width="2" stroke-linecap="round" />
                    </svg>
                </div>

                <!-- Error Message -->
                <div class="error-message">
                    <h1>403</h1>
                    <h2>Access Forbidden</h2>
                    <p class="description">
                        Sorry, you don't have permission to access this resource.
                        Your account doesn't have the required privileges to view this content.
                    </p>
                </div>

                <!-- Action Buttons -->
                <div class="action-buttons">
                    <button class="btn btn-secondary" (click)="goHome()">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor"
                                stroke-width="2" />
                            <polyline points="9,22 9,12 15,12 15,22" stroke="currentColor" stroke-width="2" />
                        </svg>
                        Home
                    </button>
                </div>

                <!-- Help Text -->
                <div class="help-text">
                    <p>
                        If you believe this is a mistake, please contact your administrator or contact support
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>